import React, { Component, PropTypes } from 'react'
import FontAwesome from 'react-fontawesome'
import styles from './RewardList.css'
import {formatDecimal, rupiah} from 'utils/formatter'
import {OverlayTrigger, Popover} from 'react-bootstrap'

class RewardInfo extends Component {

  render () {
    let {isLastRow, isFirstRow, removeReward} = this.props
    let pointAdditionalClass
    let discountAdditionalClass
    if (!removeReward && !(isFirstRow && isLastRow)) {
      if (isFirstRow) {
        pointAdditionalClass = 'no-border-radius-bottom-left'
        discountAdditionalClass = 'no-border-radius-bottom-right'
      } else if (isLastRow) {
        pointAdditionalClass = 'no-border-radius-top-left no-border-top'
        discountAdditionalClass = 'no-border-radius-top-right no-border-top'
      } else {
        pointAdditionalClass = 'no-border-radius-left no-border-top'
        discountAdditionalClass = 'no-border-radius-right no-border-top'
      }
    }

    let message, extraInfoMessage
    if (this.props.discountType === 'PERCENTAGE') {
      message = `${this.props.discount}% Discount of Total Sale `
      if (this.props.maximumDiscount) {
        extraInfoMessage = `(maximum value ${rupiah(this.props.maximumDiscount)})`
      }
    } else if (this.props.discountType === 'AMOUNT') {
      message = `${rupiah(this.props.discount)} Discount of Total Sale `
      if (this.props.minimumPurchase) {
        extraInfoMessage = `(minimum purchase ${rupiah(this.props.minimumPurchase)})`
      }
    }

    const popover = <Popover className={`${styles.popover}`} id='popover'>
      {message}<br />
      {extraInfoMessage}
    </Popover>

    return (
      <div>
        <div className='col-md-4 no-padding-right '>
          <div
            style={{borderRight: 'none', color: '#8e8e8e', fontWeight: '300'}}
            className={`form-control no-border-radius-right truncate ${pointAdditionalClass}`}
          >
            {formatDecimal(this.props.point)} Points
          </div>
        </div>
        <div className='col-md-8 no-padding-left'>
          <OverlayTrigger placement='top' overlay={popover}>
            <div
              style={{color: '#8e8e8e', fontWeight: '300'}}
              className={`${removeReward ? 'has-feedback' : ''} truncate`}
            >
              <div
                style={{color: '#8e8e8e'}}
                className={`form-control truncate no-border-radius-left ${discountAdditionalClass}`}
              >
                {message}{extraInfoMessage}
              </div>
              {removeReward && <FontAwesome
                onClick={this._onClickRemove}
                className={`form-control-feedback cursor-pointer ${styles['remove-icon']}`}
                name='times-circle'
              />}
            </div>
          </OverlayTrigger>
        </div>
      </div>
    )
  }

  _onClickRemove = (e) => {
    this.props.removeReward(this.props.index)
  }
}

RewardInfo.propTypes = {
  point: PropTypes.number.isRequired,
  discount: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired
}

export default RewardInfo



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/RewardList/RewardInfo.js